<template>
  <v-container class="grey-lighten-3 full-height">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="watermark">
            <img v-if="order?.branch?.company?.watermark && invoiceHeader" :src="getFileServerUrl + order?.branch?.company?.watermark" alt="">
          </div>

          <div class="invoice-container">
            <div class="invoice-content">
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="order?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${order?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!order?.branch?.company?.header_image && invoiceHeader">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ order.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ order.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ order.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ order.branch?.company?.email || '' }}
                            </p>
                            <p v-if="order.branch?.company?.website" class="company-text">
                              <v-icon size="small">mdi-web</v-icon>
                              {{ order.branch?.company?.website || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${order.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">PROFORMA INVOICE</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td class="details-table" colspan="100%">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>INVOICE DATE</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ formatDateView(order.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>SEASON</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.season || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>Department</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ formatDateView(order.department) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 9px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px; width: 40%;"><strong>PROFORMA INVOICE NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px; width: 60%;">{{ order.proforma_invoice_no }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>MASTER SALES CONTACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.master_sales_contact_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 2px;"><strong>PO NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 2px;">{{ order.purchase_order_no }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -10px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 70px;">
                              <strong>SUPPLIER:</strong><br/>
                              <strong>Name:</strong> {{ order.branch?.company?.name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong> {{ order.branch?.company?.phone || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 70px;">
                              <strong>BUYER:</strong><br/>
                              <strong>Name:</strong> {{ order.buyer?.company_name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.buyer?.company_address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.buyer?.company_email || '-' }} <br>
                              <strong>Phone:</strong> {{ order.buyer?.company_mobile || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row style="margin-top: -5px; margin-bottom: -20px;">
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 80px;">
                              <strong>BENEFICIARY:</strong><br/>
                              <strong>Name:</strong> {{ order.branch?.company?.name || '-' }}<br/>
                              <strong>Address:</strong> {{ order.branch?.company?.address || '-' }}<br/>
                              <strong>Email:</strong> {{ order.branch?.company?.email || '-' }}<br/>
                              <strong>Phone:</strong> {{ order.branch?.company?.phone || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: auto; border: 1px solid #000; padding: 2px; min-height: 80px;">
                              <strong>BENEFICIARY'S BANK:</strong><br/>
                              <strong>Bank Name:</strong> {{ order.beneficiary_bank?.name || '-' }}<br/>
                              <strong>Bank Address:</strong> {{ order.beneficiary_bank?.branch || '' }}, {{ order.beneficiary_bank?.address || '-' }}<br/>
                              <strong>A/C Name:</strong> {{ order.beneficiary_bank?.account_name || '-' }}<br/>
                              <strong>A/C No:</strong> {{ order.beneficiary_bank?.account_no || '-' }}<br/>
                              <strong>Swift Code:</strong> {{ order.beneficiary_bank?.swift_code || '-' }}<br/>
                              <!-- <strong>Routing No:</strong> {{ order.beneficiary_bank?.routing_no || '-' }}<br/> -->
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Breakdown Table -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="dep-table details-table mt-5" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px;">ORDER NUMBER</th>
                            <th style="border: 1px solid #000; padding: 2px;">STYLE NUMBER</th>
                            <th style="border: 1px solid #000; padding: 2px;">DESCRIPTION</th>
                            <th style="border: 1px solid #000; padding: 2px;">HS CODE</th>
                            <th style="border: 1px solid #000; padding: 2px;">COMPOSITION</th>
                            <th style="border: 1px solid #000; padding: 2px;">COLOR NAME</th>
                            <th style="border: 1px solid #000; padding: 2px;">SIZE RANGE</th>
                            <th style="border: 1px solid #000; padding: 2px;">QUANTITY</th>
                            <th style="border: 1px solid #000; padding: 2px;">UNIT PRICE</th>
                            <th style="border: 1px solid #000; padding: 2px;">CURRENCY</th>
                            <th style="border: 1px solid #000; padding: 2px;">TOTAL AMOUNT</th>
                            <th style="border: 1px solid #000; padding: 2px;">CARGO RECV. DATE</th>
                            <th style="border: 1px solid #000; padding: 2px;">ETD DATE</th>
                            <th style="border: 1px solid #000; padding: 2px;">DESTINATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in order.breakdowns" :key="row.id">
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.po }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.style_number }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.description }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.hs_code }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.composition }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.color_name }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.size_range }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.quantity }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.unit_price }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.currency?.code }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.total_amount }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ formatDateView(row.cargo_receiving_date) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ formatDateView(row.etd_date) }}</td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;">{{ row.destination }}</td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;" colspan="5"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;" colspan="2"><strong>Total</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>{{ order?.total_quantity }}</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"><strong>{{ order?.currency?.symbol }} {{ order?.total_amount }}</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;"></td>
                          </tr>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;" colspan="5"></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;" colspan="2"><strong>In Words</strong></td>
                            <td style="border: 1px solid #000; padding: 2px; text-align: center;" colspan="7"><strong>{{ convertNumberToWords(order?.total_amount) }}</strong></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Shipment Terms -->
                  <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <table class="footer-table order-table mt-5" style="width: 100%; border-collapse: collapse; font-size: 9px;">
                        <tbody>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>From</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.shipment_from || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>TO</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.shipment_to || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Payment Terms</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.payment_term?.name || '-' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Shipment Mode</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.shipping_mode?.name || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Incoterm</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order?.incoterm?.name || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Partial Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.partial_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Inspection Certificate By</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.inspaction_certificate_by || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Short/Excess Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">+/- {{ order.short_or_excess_shipment_percent || '-' }}%</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Transhipment</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.transhipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>LC Expiry Date</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.lc_expiry_date || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Port Of Loading</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.loading_port?.name || '-' }}</td>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Early Shipment</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;"> {{ order.early_shipment == 'not_allowed' ? 'Not Allowed' : 'Allowed' }}</td>
                          </tr>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left;"><strong>Destination Of Loading</strong></th>
                            <td style="border: 1px solid #000; padding: 2px;">{{ order.destination_port?.name || '-' }}</td>
                            <td colspan="4" style="border: 1px solid #000; padding: 2px;"></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Terms & Conditions -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; background-color: #ffffff;"><strong>TERM & CONDITION OF SHIPMENT:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 2px; text-align: left; font-size: 9px; min-height: 80px; vertical-align: top; white-space: pre-wrap; word-wrap: break-word;">
                              {{ order?.terms_and_condition }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Terms & Conditions -->
                  <!-- <tr>
                    <td class="details-table" colspan="100%" style="border: none;">
                      <div class="master-box mt-4" style="font-size: 9px;">
                        <v-row>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 8px; min-height: 120px;">
                              <strong>TERM & CONDITION OF SHIPMENT:</strong><br/>
                              <div style="margin-top: 8px;">
                                {{ order.branch?.terms_and_condition || '-' }}
                              </div>
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="border: 1px solid #000; padding: 2px; min-height: 120px; text-align: center;">
                              <div style="margin-top: 40px; font-size: 9px; border-bottom: 1px solid #000; min-height: 30px;"></div>
                              <strong>SIGNATURE OF THE SUPPLIER</strong><br/>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr> -->

                  <!-- Signatures -->
                  <tr>
                    <td colspan="100%" class="details-table" style="border: none;">
                      <div style="margin-top: 10px;">
                        <v-row>
                          <v-col cols="6" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">SEAL & SIGNATURE OF THE SUPPLIER / BENEFICIARY</div>
                            </div>
                          </v-col>
                          <v-col cols="6" class="text-center">
                            <div style="padding: 2px;">
                              <div style="border-bottom: 1px solid #000; margin: 50px 0 8px 0; height: 20px;"></div>
                              <div style="text-transform: uppercase; font-weight: bold; font-size: 9px;">SEAL & SIGNATURE OF THE BUYER</div>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;">&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <!-- <img v-if="order?.branch?.company?.footer_image && invoiceHeader" :src="`${getFileServerUrl}${order?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;"> -->
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="end" class="d-print-none mt-4 ">
      <v-col cols="12"  justify="center" style="display:flex; justify-content: center;">
          <v-btn color="primary" prepend-icon="mdi-printer" @click="print(0)">
            Print without pad
          </v-btn>
          <v-btn color="primary" prepend-icon="mdi-printer" class="ml-2" @click="print(1)">
            Print with pad
          </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { formatDateView, formatDateDash } from "@/plugins/helpers";
import convertNumberToWords from "@/plugins/numberToWord";

const store = useStore();
const route = useRoute();

const invoiceHeader = ref(true);
const pagePadding = ref(0);

const order = ref({
  branch: { company: {} },
  buyer: {},
  beneficiary_bank: {},
  buyer_bank: {},
  shipping_mode: {},
  breakdowns: [],
  proforma_invoice_no: "",
  invoice_date: null,
  code: "",
});

// File server URL
const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

// Total Quantity
const totalQuantity = computed(() =>
  order.value.breakdowns.reduce((sum, r) => sum + Number(r.quantity || 0), 0)
);

// Fetch data
async function fetchDetails(id) {
  try {
    const res = await store.dispatch("getProformaInvoiceById", { id });
    if (res?.data?.data) {
      order.value = res.data.data;

      // Convert breakdown dates
      order.value.breakdowns = order.value.breakdowns.map(row => ({
        ...row,
        cargo_receiving_date: row.cargo_receiving_date ? new Date(row.cargo_receiving_date) : null,
        etd_date: row.etd_date ? new Date(row.etd_date) : null
      }));
    }
  } catch (err) {
    console.error("Error fetching order details:", err);
  }
}

const print = (isPad) => {

  if (isPad === 1) {
    invoiceHeader.value = true;
    pagePadding.value = 0;
  } else if (isPad === 0) {
    invoiceHeader.value = false;
    pagePadding.value = 100;
  }

  setTimeout(() => {

    const printContent = document.getElementById("printable-area").innerHTML;
    const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);
  
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Profoma Invoice</title>
      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
  
        @page {
          size: A4;
          margin: ${pagePadding.value}px 0;
        }
  
        html, body {
          margin: 0 ;
          padding: 0; 
          width: 100%;
          height: auto;
        }
  
        body { 
          font-family: sans-serif; 
          background:#fff; 
          color:#000; 
          -webkit-print-color-adjust: exact; 
          print-color-adjust: exact;
          margin: 0;
          padding: 0;
        }
  
        .report-paper { 
          width: 100%; 
          padding: 0 !important;
          background: #fff;
          margin: 0;
        }
  
        .invoice-container {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        .invoice-content {
          width: 100%;
          margin: 0;
          padding: 0;
          overflow: visible;
        }
  
        header img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        table {
          width: 100%;
          margin: 0;
          padding: 0;
        }
  
        footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;
          z-index: 10;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        footer img {
          width: 100%;
          display: block;
          margin: 0;
          padding: 0;
        }
  
        .page-header {
          margin-bottom: 20px;
          padding: 20px 0;
        }
  
        .header-section { 
          display: flex; 
          justify-content: space-between; 
          align-items: flex-start; 
          border-bottom: 2px solid #eee; 
          padding-bottom: 10px; 
          margin-bottom: 16px; 
        }
  
        .company-name { 
          font-size: 9px; 
          font-weight: bold; 
          text-transform: uppercase; 
          margin: 0 0 4px 0; 
        }
  
        .company-text { 
          font-size: 9px; 
          margin: 2px 0; 
          display: flex; 
          align-items: center; 
        }
  
        .logo-container img { 
          max-height: 70px; 
          max-width: 150px; 
        }
  
        .report-title { 
          font-size: 16px; 
          text-align: center; 
          margin: 8px 0; 
        }
  
        .watermark {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 0;
        }
  
        table { 
          width: 100% !important; 
          border-collapse: collapse; 
          font-size: 9px; 
          margin: 8px 0;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .details-table {
          padding: 0px 28px;
        }
  
        th, td { 
          border: none; 
          padding: 0; 
          vertical-align: middle; 
        }
  
        th { 
          text-align: center; 
          font-weight: bold;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
  
        .master-box-parent {
          border: none !important;
          page-break-inside: avoid;
        }
  
        .master-box {
          margin: 16px 0;
          page-break-inside: avoid;
        }
  
        .invoice-content {
          page-break-inside: avoid;
        }
  
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .text-left { text-align: left; }
        
        table {
          page-break-inside: avoid;
          orphans: 3;
          widows: 3;
        }
        
        tr {
          page-break-inside: avoid;
        }
        .mt-4 { 
          margin-top: 0px !important;
          margin-left: -10px !important;
          margin-right: -10px !important;
        }
        .mt-5 { 
          margin-top: 5px !important;
          margin-left: 0px !important;
          margin-right: 0px !important;
        }
        .mt-8 { margin-top: 0px !important; }
        .my-6 { margin-top: 0px !important; margin-bottom: 0px !important; }
  
        img { 
          max-width: 100% !important; 
          height: auto !important; 
        }
  
        .d-flex { display: flex; }
        .justify-space-between { justify-content: space-between; }
        .align-start { align-items: flex-start; }
        .v-row { 
          display: flex !important; 
          flex-wrap: wrap !important; 
          margin: 0;
          width: 100%;
        }
  
        .v-col-6 { 
          flex: 0 0 50% !important; 
          max-width: 50% !important; 
          padding: 0 12px 12px 12px;
          box-sizing: border-box;
          margin: 0;
        }
  
        .pa-6 { padding: 0 !important; }
  
        .order-table thead {
          display: table-header-group;
          page-break-inside: avoid;
        }
  
        .order-table tbody {
          page-break-inside: avoid;
        }
  
        /* Prevent sections from breaking across pages */
        div[style*="margin-top"], div[style*="padding"] {
          page-break-inside: avoid;
        }
  
        .order-table tbody tr {
          page-break-inside: avoid;
        }
  
        .signature-box {
          font-size: 9px;
          border: 1px solid black;
          border-radius: 5px;
          padding: 10px;
        }
  
        .signature-line {
          border-bottom: 1px solid #000;
          margin: 50px 0;
          height: 30px;
        }
  
        .signature-label {
          text-transform: uppercase;
          font-weight: bold;
          font-size: 9px;
        }
  
        .invoice-container {
          display: flex;
          flex-direction: column;
        }
  
        .invoice-content {
          flex: 1;
          overflow: visible;
          margin-top: -10px;
        }
          
        .company-info {
          flex: 1;
        }
  
        .invoice-footer {
          margin-top: auto;
          position: fixed;
          left; 0;
          bottom: 15px;
          width: 100%;    
        }
  
        @media print { 
          body {
            margin: 0;
            padding: 0;
          }
  
          .report-paper {
            margin: 0;
            padding: 0;
          }
  
          main {
            padding-top: 180px;
            padding-bottom: 150px;
            padding-left: 20px;
            padding-right: 20px;
          }
  
          .watermark {
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 0;
          }
            
          .order-table {
            page-break-inside: auto;
          }
  
          .order-table tr {
            page-break-inside: avoid;
            page-break-after: auto;
          }
  
          .order-table thead {
            display: table-header-group;
          }
        }
      </style>
      </head>
      <body>
        ${printContent}
      </body>
      </html>
    `);
  
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
    }, 500);
    invoiceHeader.value = true;
    pagePadding.value = 0;
  }, 500)

};

onMounted(() => {
  const id = route.params.id;
  if (id) fetchDetails(id);
});
</script>

<style scoped>
.full-height { min-height: 60vh; }
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 9px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 9px; }
.report-title { font-size: 16px; text-align: center; margin: 8px 0; }
.meta-box { border: 1px solid #000; padding: 2px; font-size: 9px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 9px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 2px; font-size: 9px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
}

.d-print-none {
  display: block !important;
}

@media print {
  .d-print-none {
    display: none !important;
  }
}
</style>
